import CompanyCulture from "components/CompanyCulture";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import WellnessService from "services/WellnessService";
import { TabTypeMapping } from "utils/wellness";
import Loader from "components/Loader";
import { useGlobalContext } from "store/contexts/globalContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ListItem from "./ListItem";
import { useTeamContext } from "store/contexts/teamContext";

const ListContainer = ({ activeTab, id, dispatch, videos, videosMeta }) => {
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [reloadCounter, setReloadCounter] = useState(0);
  const { team } = useTeamContext();
  const [allowActions, setAllowActions] = useState(false);
  const { checkYourTeamRole } = useGlobalContext();

  const showDefaultAvatar = [0, 1].includes(activeTab);

  const params = useParams();
  const tabsMsg = {
    0: "You don't have any motivational video",
    1: "You don't have any meditation video",
    2: "You don't have any training video",
    3: "You don't have any training documents",
  };

  useEffect(() => {
    (async () => {
      const role = await checkYourTeamRole(Number(params.teamId));
      setAllowActions([2, 3].includes(Number(role)) || [2, 3].includes(Number(team?.role_id)));
    })();
  }, [params, checkYourTeamRole, team?.role_id]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      let resp;

      if (activeTab === 3) {
        resp = await WellnessService.getTrainingDocuments({
          page: page,
          teamId: params.teamId,
        });
      } else {
        resp = await WellnessService.getWellnessVideos({
          page: page,
          teamId: params.teamId,
          type: TabTypeMapping[activeTab],
        });
      }

      const list = resp?.data?.data;
      dispatch({
        type: "setVideos",
        value: {
          teamId: params.teamId,
          hardReload: page === 1,
          videos: Array.isArray(list) ? list : list?.data ?? [],
          videosMeta: list?.meta ?? list,
        },
      });
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.teamId, page, activeTab, reloadCounter]);

  const metaData = videosMeta;

  useEffect(() => {
    setPage(1);
  }, [activeTab]);

  const getNextPageData = () => {
    setPage((state) => (state += 1));
  };

  return (
    <div className="mindfulnessContent">
      <div id={id} className="scrollArea">
        {/* additional upload button for the company culture / training documents */}
        {(activeTab === 2 || activeTab === 3) && (team?.role_id === 2 || team?.role_id === 3) && (
          <CompanyCulture
            activeTab={activeTab}
            setReload={() => {
              setPage(1);
              setReloadCounter((prev) => prev + 1);
            }}
          />
        )}
        <InfiniteScroll
          style={{ overflow: "hidden" }}
          dataLength={metaData?.links?.length ?? 0}
          next={getNextPageData}
          hasMore={metaData?.to !== metaData?.total}
          scrollableTarget={id}
          endMessage={
            <p
              style={{
                textAlign: "center",
                marginTop: "3rem",
                marginBottom: "3rem",
              }}
            >
              {videos.length === 0 && !isLoading ? (
                <b>{tabsMsg[activeTab]}</b>
              ) : (
                videos.length !== 0 && !isLoading && <b>You have seen all! </b>
              )}
            </p>
          }
        >
          <div className={activeTab === 3 ? "documentListContainer" : "videoListContainer"}>
            {videos.map((v, iDx) => (
              <ListItem
                key={v.id ?? iDx}
                item={v}
                allowActions={allowActions || [2, 3].includes(Number(team?.role_id))}
                showAction={activeTab === 2 || activeTab === 3}
                activeTab={activeTab}
                setReload={(videoId) => {
                  dispatch({
                    type: "setVideos",
                    value: {
                      teamId: params.teamId,
                      hardReload: page === 1,
                      videos: videos.filter((s) => s.id !== videoId),
                    },
                  });
                }}
                onUpdate={() => {
                  setPage(1);
                  setReloadCounter((prev) => prev + 1);
                }}
                showDefaultAvatar={showDefaultAvatar}
              />
            ))}
          </div>
          {isLoading && (
            <div className="d-flex justify-content-center">
              <Loader />
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default ListContainer;
